import { RockDocDao } from '@rock/db-admin';
import type { RockDocId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atomFamily } from 'jotai/utils';

const dao = new RockDocDao();

export const rockDocsState = dao.rockDocsAtom();

export const rockDocState = atomFamily((docId: RockDocId | undefined) => dao.rockDocAtom(docId), shallowEqual);

export const considerationDocsState = dao.considerationDocsAtom();

export const considerationDocState = atomFamily(
    (docId: RockDocId | undefined) => dao.considerationDocAtom(docId),
    shallowEqual,
);

export const lessonDocState = atomFamily((docId: RockDocId | undefined) => dao.lessonDocAtom(docId), shallowEqual);

export const taskDocsState = dao.taskDocsAtom();

export const taskDocState = atomFamily((docId: RockDocId | undefined) => dao.taskDocAtom(docId), shallowEqual);
